import { default as config } from '@config';
import { 
    setLocalData,
    getLocalData,
    shuffleArray,
    gotoLogin,
    dateFormat,
    getImgPath,
    phoneAreaCode,
    gotoPage,
    toast,
    showLoading,
    hideLoading,
    ganaSendEvent,
    checkBrowser,
    formatPrice,
} from '@util';
import { useCommonStore } from '@stores/common';

import logo_2 from '@imgs/logo_2.png';
//mx
import XmasLogo_gana100 from '@imgCom/activity/XmasUI/logo/MX/gana100/logo_2.png';
import XmasLogo_gana100_L from '@imgCom/activity/XmasUI/logo/MX/gana100/common_logo_pro01.png';
import XmasLogo_mxjugar from '@imgCom/activity/XmasUI/logo/MX/mxjugar/logo_2.png';
import XmasLogo_mxjugar_L from '@imgCom/activity/XmasUI/logo/MX/mxjugar/common_logo_pro01.png';
import XmasLogo_777suerte from '@imgCom/activity/XmasUI/logo/MX/777suerte/logo_2.png';
import XmasLogo_777suerte_L from '@imgCom/activity/XmasUI/logo/MX/777suerte/common_logo_pro01.png';
import XmasLogo_777jugar from '@imgCom/activity/XmasUI/logo/MX/777jugar/logo_2.png';
import XmasLogo_777jugar_L from '@imgCom/activity/XmasUI/logo/MX/777jugar/common_logo_pro01.png';
import XmasLogo_lanawin from '@imgCom/activity/XmasUI/logo/MX/lanawin/logo_2.png';
import XmasLogo_lanawin_L from '@imgCom/activity/XmasUI/logo/MX/lanawin/common_logo_pro01.png';
import XmasLogo_mxgana from '@imgCom/activity/XmasUI/logo/MX/mxgana/logo_2.png';
import XmasLogo_mxgana_L from '@imgCom/activity/XmasUI/logo/MX/mxgana/common_logo_pro01.png';
import XmasLogo_jugarmx from '@imgCom/activity/XmasUI/logo/MX/jugarmx/logo_2.png';
import XmasLogo_jugarmx_L from '@imgCom/activity/XmasUI/logo/MX/jugarmx/common_logo_pro01.png';
import XmasLogo_001mx from '@imgCom/activity/XmasUI/logo/MX/001mx/logo_2.png';
import XmasLogo_001mx_L from '@imgCom/activity/XmasUI/logo/MX/001mx/common_logo_pro01.png';
import XmasLogo_mxbet100 from '@imgCom/activity/XmasUI/logo/MX/mxbet100/logo_2.png';
import XmasLogo_mxbet100_L from '@imgCom/activity/XmasUI/logo/MX/mxbet100/common_logo_pro01.png';
import XmasLogo_loarbet from '@imgCom/activity/XmasUI/logo/MX/loarbet/logo_2.png';
import XmasLogo_loarbet_L from '@imgCom/activity/XmasUI/logo/MX/loarbet/common_logo_pro01.png';
import XmasLogo_winmx001 from '@imgCom/activity/XmasUI/logo/MX/winmx001/logo_2.png';
import XmasLogo_winmx001_L from '@imgCom/activity/XmasUI/logo/MX/winmx001/common_logo_pro01.png';
import XmasLogo_winmx888 from '@imgCom/activity/XmasUI/logo/MX/winmx888/logo_2.png';    
import XmasLogo_winmx888_L from '@imgCom/activity/XmasUI/logo/MX/winmx888/common_logo_pro01.png';    
//CL
import XmasLogo_clluckia from '@imgCom/activity/XmasUI/logo/CL/clluckia/logo_2.png';
import XmasLogo_clluckia_L from '@imgCom/activity/XmasUI/logo/CL/clluckia/common_logo_pro01.png';
import XmasLogo_coquimbocl from '@imgCom/activity/XmasUI/logo/CL/coquimbocl/logo_2.png';
import XmasLogo_coquimbocl_L from '@imgCom/activity/XmasUI/logo/CL/coquimbocl/common_logo_pro01.png';
import XmasLogo_enjoycl from '@imgCom/activity/XmasUI/logo/CL/enjoycl/logo_2.png';
import XmasLogo_enjoycl_L from '@imgCom/activity/XmasUI/logo/CL/enjoycl/common_logo_pro01.png';
import XmasLogo_vinacl from '@imgCom/activity/XmasUI/logo/CL/vinacl/logo_2.png';
import XmasLogo_vinacl_L from '@imgCom/activity/XmasUI/logo/CL/vinacl/common_logo_pro01.png';
//CO
import XmasLogo_apostarco from '@imgCom/activity/XmasUI/logo/CO/apostarco/logo_2.png';
import XmasLogo_apostarco_L from '@imgCom/activity/XmasUI/logo/CO/apostarco/common_logo_pro01.png';
import XmasLogo_jugarco from '@imgCom/activity/XmasUI/logo/CO/jugarco/logo_2.png';
import XmasLogo_jugarco_L from '@imgCom/activity/XmasUI/logo/CO/jugarco/common_logo_pro01.png';
import XmasLogo_jugarcol from '@imgCom/activity/XmasUI/logo/CO/jugarcol/logo_2.png';
import XmasLogo_jugarcol_L from '@imgCom/activity/XmasUI/logo/CO/jugarcol/common_logo_pro01.png';
import XmasLogo_suerteco from '@imgCom/activity/XmasUI/logo/CO/suerteco/logo_2.png';
import XmasLogo_suerteco_L from '@imgCom/activity/XmasUI/logo/CO/suerteco/common_logo_pro01.png';
import XmasLogo_suertecol from '@imgCom/activity/XmasUI/logo/CO/suertecol/logo_2.png';
import XmasLogo_suertecol_L from '@imgCom/activity/XmasUI/logo/CO/suertecol/common_logo_pro01.png';
//PE
import XmasLogo_lahaciendape from '@imgCom/activity/XmasUI/logo/PE/lahaciendape/logo_2.png';
import XmasLogo_lahaciendape_L from '@imgCom/activity/XmasUI/logo/PE/lahaciendape/common_logo_pro01.png';
import XmasLogo_pefiesta from '@imgCom/activity/XmasUI/logo/PE/pefiesta/logo_2.png';
import XmasLogo_pefiesta_L from '@imgCom/activity/XmasUI/logo/PE/pefiesta/common_logo_pro01.png';
import XmasLogo_pefortuna from '@imgCom/activity/XmasUI/logo/PE/pefortuna/logo_2.png';
import XmasLogo_pefortuna_L from '@imgCom/activity/XmasUI/logo/PE/pefortuna/common_logo_pro01.png';
import XmasLogo_peluckia from '@imgCom/activity/XmasUI/logo/PE/peluckia/logo_2.png';
import XmasLogo_peluckia_L from '@imgCom/activity/XmasUI/logo/PE/peluckia/common_logo_pro01.png';
import XmasLogo_peluckie from '@imgCom/activity/XmasUI/logo/PE/peluckie/logo_2.png';
import XmasLogo_peluckie_L from '@imgCom/activity/XmasUI/logo/PE/peluckie/common_logo_pro01.png';

import XmasLoading_gif from '@imgCom/activity/XmasUI/XmasLoading_gif.gif';
import XmasLoading_bg from '@imgCom/activity/XmasUI/XmasLoading_bg.webp';
import XmasMain_bg from '@imgCom/activity/XmasUI/XmasMain_bg.webp';
import XmasBtn_l from '@imgCom/activity/XmasUI/XmasBtn_l.webp';
import XmasBtn_c from '@imgCom/activity/XmasUI/XmasBtn_c.webp';
import XmasBtn_r from '@imgCom/activity/XmasUI/XmasBtn_r.webp';
import XmasBtn_left_list from '@imgCom/activity/XmasUI/XmasBtn_left_list.webp';
import XmasBtn_Tabbar from '@imgCom/activity/XmasUI/XmasBtn_Tabbar.webp';
import Xmas_paomadeng_icon from '@imgCom/activity/XmasUI/Xmas_paomadeng_icon.webp';
import XmasLB_bg from '@imgCom/activity/XmasUI/XmasLB_bg.webp';
import LB_bg from '@imgCom/activity/recharge/bg.png';
import LB_bg2 from '@imgCom/activity/recharge/bg2.png';
import envelope from '@imgCom/activity/recharge/envelope.png';
import open_envelope from '@imgCom/activity/recharge/open-envelope.png';
import XmasLB_valBg from '@imgCom/activity/XmasUI/XmasLB_valBg.webp';
import Xmas_r_contentBg from '@imgCom/activity/XmasUI/recharge/Xmas_r_contentBg.webp';
import Xmas_r_itemTitieBg from '@imgCom/activity/XmasUI/recharge/Xmas_r_itemTitieBg.webp';
import Xmas_r_lihe_001 from '@imgCom/activity/XmasUI/recharge/Xmas_r_lihe_001.webp';
import Xmas_r_lihe_002 from '@imgCom/activity/XmasUI/recharge/Xmas_r_lihe_002.webp';
import Xmas_r_lihe_003 from '@imgCom/activity/XmasUI/recharge/Xmas_r_lihe_003.webp';
import Xmas_r_lihe_004 from '@imgCom/activity/XmasUI/recharge/Xmas_r_lihe_004.webp';
import Xmas_r_lihe_005 from '@imgCom/activity/XmasUI/recharge/Xmas_r_lihe_005.webp';
import Xmas_r_lihe_006 from '@imgCom/activity/XmasUI/recharge/Xmas_r_lihe_006.webp';
import Xmas_r_pmdBg from '@imgCom/activity/XmasUI/recharge/Xmas_r_pmdBg.webp';
import Xmas_r_rwdTitleBg from '@imgCom/activity/XmasUI/recharge/Xmas_r_rwdTitleBg.webp';
import Xmas_r_itemTip1 from '@imgCom/activity/XmasUI/recharge/Xmas_r_itemTip1.png';
import Xmas_r_itemTip2 from '@imgCom/activity/XmasUI/recharge/Xmas_r_itemTip2.png';
import Xmas_r_snow from '@imgCom/activity/XmasUI/recharge/Xmas_r_snow.webp';
import Xmas_r_upBg from '@imgCom/activity/XmasUI/recharge/Xmas_r_upBg.webp';
import Xmas_r_title_PE from '@imgCom/activity/XmasUI/recharge/Xmas_r_title_PE.webp';
import Xmas_r_title_MX from '@imgCom/activity/XmasUI/recharge/Xmas_r_title_MX.webp';
import Xmas_r_title_CO from '@imgCom/activity/XmasUI/recharge/Xmas_r_title_CO.webp';
import Xmas_r_title_CL from '@imgCom/activity/XmasUI/recharge/Xmas_r_title_CL.webp';
import Xmas_r_rwdItemBg from '@imgCom/activity/XmasUI/recharge/Xmas_r_rwdItemBg.webp';
import Xmas_r_rwdItemBg2 from '@imgCom/activity/XmasUI/recharge/Xmas_r_rwdItemBg2.webp';
import Xmas_r_rwdBtn_lock from '@imgCom/activity/XmasUI/recharge/Xmas_r_rwdBtn_lock.webp';
import Xmas_r_rwd_yes from '@imgCom/activity/XmasUI/recharge/Xmas_r_rwd_yes.webp';
import Xmas_rwd_bg from '@imgCom/activity/XmasUI/Xmas_rwd_bg.webp';
import Xmas_rwd_closeBtn from '@imgCom/activity/XmasUI/Xmas_rwd_closeBtn.webp';
import Xmas_pop_headShow from '@imgCom/activity/XmasUI/Xmas_pop_headShow.webp';
import Xmas_rwd_title from '@imgCom/activity/XmasUI/Xmas_rwd_title.webp';
import Xmas_main_pop_bg_1 from '@imgCom/activity/XmasUI/Xmas_main_pop_bg_1.webp';
import Xmas_main_pop_bg_2 from '@imgCom/activity/XmasUI/Xmas_main_pop_bg_2.webp';
import Xmas_main_pop_cellBg from '@imgCom/activity/XmasUI/Xmas_main_pop_cellBg.webp';
import XmasBtn_tip from '@imgCom/activity/XmasUI/XmasBtn_tip.webp';
import Xmas_lock from '@imgCom/activity/XmasUI/Xmas_lock.webp';

import { ref } from 'vue';

const chatUnreadCount = ref(0);
// 导出 ********************************************************************************************************************************************************************************************************************************************************************************************************************
export const zutil = {
    /**获取活动类型 0没活动 1圣诞节 2temp */
    getActivityType(){
        if(getLocalData('country')=='AR'){
            return 0;
        }
        return 0;
    },
    main_bg_style() {
        if(this.getActivityType() == 0){
            return {}
        }else if(this.getActivityType() == 1){
            let style = {
                // position: 'fixed',
                // left: '0',
                // top: '0',
                // display: 'flex',
                height: '100vh',
                width: '100vw',
                // overflow: 'hidden',
                background: "url('" + zutil.getImage('XmasMain_bg') + "') no-repeat bottom center !important",
                backgroundSize: '100% auto !important',
            };
            return style;
        }
	},
    setXmasLocalData(key,val){
        const store = useCommonStore();
        let XmasLocalDataKey = `${store.baseUserInfo.userName}-XmasLocalData`
        let saveData = getLocalData(XmasLocalDataKey);
        if(!saveData){
            window.log("[zutil] saveData")
            saveData = {
                /**领奖弹窗数据 6种礼包，买哪个弹哪个 数据不为null时弹出 */
                firstBuyPopDataArr:[null,null,null,null,null,null],
                /**首页弹窗数据 */
                mainPopData:null,
                /**礼包状态 0未购买 1已点购买待付款 */
                payStatus:[0,0,0,0,0,0],
                /**首页上线弹窗 */
                onlinePop:'',
                /**首页领取弹窗 */
                receivePop:'',
                /**充值埋点 */
                enterEvent:'',
                buttonEvent:['','','','','',''],
                showRechargeEvent:['','','','','',''],
                // rechargeEvent:['','','']
            }
        }
        if(saveData[key] === undefined){
            window.log("[zutil] !!! WARN !!! ------> unknown key:",key,saveData[key])
        }
        saveData[key] = val;
        // window.log("[zutil] setXmasLocalData saveData:",saveData)
        setLocalData(XmasLocalDataKey,saveData)
        return saveData;
    },
    getXmasLocalData(key){
        const store = useCommonStore();
        let XmasLocalDataKey = `${store.baseUserInfo.userName}-XmasLocalData`
        let saveData = getLocalData(XmasLocalDataKey);
        if(!saveData){
            saveData = this.setXmasLocalData("autoCreate",true)
        }
        if(key && saveData){
            if(saveData[key]){
                return saveData[key];
            }else{
                window.log("[zutil] !!! WARN !!! ------> unknown key:",key)
                return null;
            }
        }
        return saveData;
    },
    
    /**倒计时 */
    secondFormat(_sec){
        let leftSec = _sec;
        let day = Math.floor(leftSec / (24*60*60));
        leftSec = leftSec % (24*60*60);
        let hour = Math.floor(leftSec / (60*60));
        leftSec = leftSec % (60*60);
        let min = Math.floor(leftSec / 60);
        let sec = leftSec % 60;

        if(day<10){
            day = '0'+day;
        }else{
            day = ''+day;
        }
        if(hour<10){
            hour = '0'+hour;
        }else{
            hour = ''+hour;
        }
        if(min<10){
            min = '0'+min;
        }else{
            min = ''+min;
        }
        if(sec<10){
            sec = '0'+sec;
        }else{
            sec = ''+sec;
        }
        // if(day > 0){
        //     return day+"D "+hour+":"+min+":"+sec;
        // }
        // return hour+":"+min+":"+sec;
        return day+" D / "+hour+" H / "+min+" M";// +" / "+sec+" S";
    },
    /**格式化价格 */
    priceFormat(_price){
        return _price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    onSocketData(socketData){
        window.log("[zutil] onSocketData",socketData)
        // let showXmas = getLocalData('showXmas')
        // if(showXmas !== '1'){
        //     window.log("[zutil] onSocketData->return! showXmas:",showXmas)
        //     return;
        // }
        if(socketData.code == 'CHRISTMAS_GIFT_ONLINE_NOTICE'){//圣诞活动弹窗 未购买
            let today = this.dateFormat();
            if(today == this.getXmasLocalData("onlinePop")){
                window.log("[zutil] 上线弹窗今日已弹出",today)
                return;
            }
            this.setXmasLocalData("onlinePop",today);

            let data = JSON.parse(socketData.content);
            let mainPopData ={type:1,sellCnt:data.buyPeoples,maxRwd:data.rewardAmountTotal};
            this.setXmasLocalData("mainPopData",mainPopData)

            const store = useCommonStore();
            store.setIsShowXmasActivityDialog(true)
            // uni.$emit('XmasRechargeActivity', { msg: 'XmasRechargeActivity'})
        }else if(socketData.code == 'CHRISTMAS_GIFT_RECEIVE_NOTICE'){//圣诞礼包活动领取弹窗
            let today = this.dateFormat();
            if(today == this.getXmasLocalData("receivePop")){
                window.log("[zutil] 领取弹窗今日已弹出",today)
                return;
            }
            this.setXmasLocalData("receivePop",today);

            let data = JSON.parse(socketData.content);
            window.log("[zutil] onSocketData() data",data)
            let sortArr = data.sort((a,b)=>{
                if(a.status > b.status && (a.status != 1 && b.status == 1)){
                    return -1;
                }
                return 1;
            })
            
            window.log("[zutil] onSocketData() sortArr",sortArr)
            let mainPopData ={type:2,giftInfoArr:data};
            this.setXmasLocalData("mainPopData",mainPopData)

            const store = useCommonStore();
            store.setIsShowXmasActivityDialog(true)
            // uni.$emit('XmasRechargeActivity', { msg: 'XmasRechargeActivity'})
        }else if(socketData.code == 'CHRISTMAS_GIFT_FIRST_RECEIVE_NOTICE'){//购买，第一天自动领取
            let data = JSON.parse(socketData.content);
            window.log("[zutil] onSocketData() data",data)

            let firstBuyPopDataArr = this.getXmasLocalData("firstBuyPopDataArr")
            firstBuyPopDataArr[data.index-1] = {
                idx:data.index-1,
                rwd:data.currentDayRewardAmount,
                day:1,
                totalRwd:data.rewardAmountTotal
            }
            this.setXmasLocalData("firstBuyPopDataArr",firstBuyPopDataArr)

            const store = useCommonStore();
            store.setIsShowXmasActivityDialog(true)
            uni.$emit('XmasRechargeActivity', { msg: 'XmasRechargeActivity'})

        }else if(socketData.code == 'NEWBIE_GIFT_JOIN_NOTICE'){//注册送转盘弹窗
            // 新手大礼包
            let data = JSON.parse(socketData.content);
            window.log("[zutil] onSocketData() 新手大礼包 data",data)
            const store = useCommonStore();
            store.setNewUserRouletteDia(true, data);
        }else if(socketData.code == 'CHRISTMAS_TREE_NOTICE'){//圣诞树弹窗
            const dataChrims = JSON.parse(socketData.content || '{}');
            console.warn('dataChrims',dataChrims)
            const store = useCommonStore();
            store.setChrisTreeData(dataChrims)
            store.setIsShowXmasActivityDialog(true)
        }
        

        // let firstBuyPopDataArr = [
        //     null,
        //     {idx:1,rwd:200,day:1,totalRwd:2000},
        //     {idx:2,rwd:300,day:2,totalRwd:3000},
        //     null,
        //     {idx:4,rwd:500,day:7,totalRwd:5000},
        //     null
        // ]

        // this.setXmasLocalData("firstBuyPopDataArr",firstBuyPopDataArr)

    },

    /**普通埋点 */
    sendEvent(keyStr){
        const store = useCommonStore();
        let params = {
            country: getLocalData('country'),
            lang: getLocalData('lang'),
            siteCode: getLocalData('siteCode'),
            userName: store.baseUserInfo.userName,
        }
        window.log("[zutil] sendEvent:",keyStr,params)
        ganaSendEvent(keyStr, params);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // util ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    gotoLogin(){
        window.log("[zutil] gotoLogin() from util")
        gotoLogin();
    },
    getImgPath(path){
        return getImgPath(path);
    },
    phoneAreaCode(){
        return phoneAreaCode();
    },
    getLocalData(key){
        return getLocalData(key);
    },
    gotoPage(page){
        gotoPage(page);
    },
    toast(msg){
        toast(msg);
    },
    showLoading(){
        showLoading();
    },
    hideLoading(){
        hideLoading();
    },
    dateFormat(date = new Date(), format = 'YYYY-MM-DD'){
        return dateFormat(date,format);
    },
    checkBrowser(){
        return checkBrowser();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // 资源读取 *********************************************************************************************************************
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    getImage(param) {
        // console.log('getImage', param, bannerImg);
        switch (param) {
            case 'logo_2':
                if(this.getActivityType()==1){
                    // window.log("getImage config._key",config._key)
                    if(config._key == 'samba100'){//mx_test
                        return XmasLogo_gana100
                    }else if(config._key == 'gana100'){
                        return XmasLogo_gana100
                    }else if(config._key == 'mxjugar'){
                        return XmasLogo_mxjugar
                    }else if(config._key == 'suerte777'){
                        return XmasLogo_777suerte
                    }else if(config._key == 'jugar777'){
                        return XmasLogo_777jugar
                    }else if(config._key == 'lanawin'){
                        return XmasLogo_lanawin
                    }else if(config._key == 'mxgana'){
                        return XmasLogo_mxgana
                    }else if(config._key == 'jugarmx'){
                        return XmasLogo_jugarmx
                    }else if(config._key == 'mx001'){
                        return XmasLogo_001mx
                    }else if(config._key == 'mxbet100'){
                        return XmasLogo_mxbet100
                    }else if(config._key == 'loarbet'){
                        return XmasLogo_loarbet
                    }else if(config._key == 'winmx001'){
                        return XmasLogo_winmx001
                    }else if(config._key == 'winmx888'){
                        return XmasLogo_winmx888
                    }else if(config._key == 'suerteco'){
                        return XmasLogo_suerteco
                    }else if(config._key == 'suertecol'){
                        return XmasLogo_suertecol
                    }else if(config._key == 'jugarcol'){
                        return XmasLogo_jugarcol
                    }else if(config._key == 'jugarco'){
                        return XmasLogo_jugarco
                    }else if(config._key == 'apostarco'){
                        return XmasLogo_apostarco
                    }else if(config._key == 'vinacl'){
                        return XmasLogo_vinacl
                    }else if(config._key == 'coquimbocl'){
                        return XmasLogo_coquimbocl
                    }else if(config._key == 'clluckia'){
                        return XmasLogo_clluckia
                    }else if(config._key == 'enjoycl'){
                        return XmasLogo_enjoycl
                    }else if(config._key == 'lahaciendape'){
                        return XmasLogo_lahaciendape
                    }else if(config._key == 'peluckie'){
                        return XmasLogo_peluckie
                    }else if(config._key == 'pefiesta'){
                        return XmasLogo_pefiesta
                    }else if(config._key == 'pefortuna'){
                        return XmasLogo_pefortuna
                    }else if(config._key == 'peluckia'){
                        return XmasLogo_peluckia
                    }
                }else if(this.getActivityType()==2){
                }
                return logo_2;
                break;
            case 'logo_2_L':
                if(this.getActivityType()==1){
                    // window.log("getImage config._key",config._key)
                    if(config._key == 'samba100'){//mx_test
                        return XmasLogo_gana100_L
                    }else if(config._key == 'gana100'){
                        return XmasLogo_gana100_L
                    }else if(config._key == 'mxjugar'){
                        return XmasLogo_mxjugar_L
                    }else if(config._key == 'suerte777'){
                        return XmasLogo_777suerte_L
                    }else if(config._key == 'jugar777'){
                        return XmasLogo_777jugar_L
                    }else if(config._key == 'lanawin'){
                        return XmasLogo_lanawin_L
                    }else if(config._key == 'mxgana'){
                        return XmasLogo_mxgana_L
                    }else if(config._key == 'jugarmx'){
                        return XmasLogo_jugarmx_L
                    }else if(config._key == 'mx001'){
                        return XmasLogo_001mx_L
                    }else if(config._key == 'mxbet100'){
                        return XmasLogo_mxbet100_L
                    }else if(config._key == 'loarbet'){
                        return XmasLogo_loarbet_L
                    }else if(config._key == 'winmx001'){
                        return XmasLogo_winmx001_L
                    }else if(config._key == 'winmx888'){
                        return XmasLogo_winmx888_L
                    }else if(config._key == 'suerteco'){
                        return XmasLogo_suerteco_L
                    }else if(config._key == 'suertecol'){
                        return XmasLogo_suertecol_L
                    }else if(config._key == 'jugarcol'){
                        return XmasLogo_jugarcol_L
                    }else if(config._key == 'jugarco'){
                        return XmasLogo_jugarco_L
                    }else if(config._key == 'apostarco'){
                        return XmasLogo_apostarco_L
                    }else if(config._key == 'vinacl'){
                        return XmasLogo_vinacl_L
                    }else if(config._key == 'coquimbocl'){
                        return XmasLogo_coquimbocl_L
                    }else if(config._key == 'clluckia'){
                        return XmasLogo_clluckia_L
                    }else if(config._key == 'enjoycl'){
                        return XmasLogo_enjoycl_L
                    }else if(config._key == 'lahaciendape'){
                        return XmasLogo_lahaciendape_L
                    }else if(config._key == 'peluckie'){
                        return XmasLogo_peluckie_L
                    }else if(config._key == 'pefiesta'){
                        return XmasLogo_pefiesta_L
                    }else if(config._key == 'pefortuna'){
                        return XmasLogo_pefortuna_L
                    }else if(config._key == 'peluckia'){
                        return XmasLogo_peluckia_L
                    }
                }else if(this.getActivityType()==2){
                }
                return null;
                break;
            case 'XmasLoading_gif':
                return XmasLoading_gif;
                // return 'https://img.js.design/assets/img/6577c17cf29f29ce7046edeb.gif'
                break;
            case 'XmasLoading_bg':
                return XmasLoading_bg;
                break;
            case 'XmasMain_bg':
                return XmasMain_bg;
                break;
            case 'XmasBtn_l':
                return XmasBtn_l;
                break;
            case 'XmasBtn_c':
                return XmasBtn_c;
                break;
            case 'XmasBtn_r':
                return XmasBtn_r;
                break;
            case 'XmasBtn_left_list':
                return XmasBtn_left_list;
                break;
            case 'XmasBtn_Tabbar':
                return XmasBtn_Tabbar;
                break;
            case 'Xmas_paomadeng_icon':
                return Xmas_paomadeng_icon;
                break;
            case 'LB_bg':
                return LB_bg;
                break;
            case 'LB_bg2':
                return LB_bg2;
                break;
            case 'XmasLB_bg':
                return XmasLB_bg;
                break;
            case 'XmasLB_valBg':
                return XmasLB_valBg;
                break;
            case 'envelope':
                return envelope;
                break;
            case 'open_envelope':
                return open_envelope;
                break;
            case 'Xmas_r_contentBg':
                return Xmas_r_contentBg;
                break;
            case 'Xmas_r_itemTitieBg':
                return Xmas_r_itemTitieBg;
                break;
            case 'Xmas_r_lihe_001':
                return Xmas_r_lihe_001;
                break;
            case 'Xmas_r_lihe_002':
                return Xmas_r_lihe_002;
                break;
            case 'Xmas_r_lihe_003':
                return Xmas_r_lihe_003;
                break;
            case 'Xmas_r_lihe_004':
                return Xmas_r_lihe_004;
                break;
            case 'Xmas_r_lihe_005':
                return Xmas_r_lihe_005;
                break;
            case 'Xmas_r_lihe_006':
                return Xmas_r_lihe_006;
                break;
            case 'Xmas_r_pmdBg':
                return Xmas_r_pmdBg;
                break;
            case 'Xmas_r_rwdTitleBg':
                return Xmas_r_rwdTitleBg;
                break;
            case 'Xmas_r_snow':
                return Xmas_r_snow;
                break;
            case 'Xmas_r_upBg':
                return Xmas_r_upBg;
                break;
            case 'Xmas_r_rwdItemBg':
                return Xmas_r_rwdItemBg;
                break;
            case 'Xmas_r_rwdItemBg2':
                return Xmas_r_rwdItemBg2;
                break;
            case 'Xmas_r_rwdBtn_lock':
                return Xmas_r_rwdBtn_lock;
                break;
            case 'Xmas_r_rwd_yes':
                return Xmas_r_rwd_yes;
                break;
            case 'Xmas_rwd_bg':
                return Xmas_rwd_bg;
                break;
            case 'Xmas_rwd_closeBtn':
                return Xmas_rwd_closeBtn;
                break;
            case 'Xmas_rwd_title':
                return Xmas_rwd_title;
                break;
            case 'Xmas_main_pop_bg_1':
                return Xmas_main_pop_bg_1;
                break;
            case 'Xmas_main_pop_bg_2':
                return Xmas_main_pop_bg_2;
                break;
            case 'Xmas_main_pop_cellBg':
                return Xmas_main_pop_cellBg;
                break;
            case 'XmasBtn_tip':
                return XmasBtn_tip;
                break;
            case 'Xmas_lock':
                return Xmas_lock;
                break;
            case 'Xmas_r_title_PE':
                return Xmas_r_title_PE;
                break;
            case 'Xmas_r_title_MX':
                return Xmas_r_title_MX;
                break;
            case 'Xmas_r_title_CO':
                return Xmas_r_title_CO;
                break;
            case 'Xmas_r_title_CL':
                return Xmas_r_title_CL;
                break;
            case 'Xmas_r_itemTip1':
                return Xmas_r_itemTip1;
                break;
            case 'Xmas_r_itemTip2':
                return Xmas_r_itemTip2;
                break;
            case 'Xmas_pop_headShow':
                return Xmas_pop_headShow;
                break;
            // case 'check_1':
            //     return check_1;
            //     break;
            // case 'check_1':
            //     return check_1;
            //     break;


            default:
                window.log("~~~~~~~~~~~~~~~~~~[ERROR!!!] getImage 未添加的图片",param)
                break;
        }
        return null;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // chat 客服 聊天 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    setChatUnreadCount(cnt){
        chatUnreadCount.value = cnt;
        window.log("[zutil] setChatUnreadCount",chatUnreadCount.value)
    },
    get chatUnreadCountRef(){
        return chatUnreadCount.value;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // 格式化 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    /**千位加逗号 返回string */
    numberFormatStr(_num){
        let formatter = {
            thousands: ',',
            decimal: '.',
            decimalsNum: 2,
            kUnit: 'K',
            mbUnit: 'M',
        };
        let country = getLocalData('country');
        switch (country) {
            case 'MX':
                formatter.kUnit = 'MIL';
                formatter.mbUnit = 'MILLÓN';
                break;
            case 'BR':
                formatter.thousands = '.';
                formatter.decimal = ',';
                break;
            case 'AR':
                formatter.thousands = '.';
                formatter.decimal = ',';
                formatter.kUnit = 'MIL';
                formatter.mbUnit = 'MILLÓN';
                break;
            case 'CO':
                formatter.thousands = '.';
                formatter.decimal = ',';
                formatter.decimalsNum = 0; // 哥伦比亚不展示小数部分
                formatter.kUnit = 'MIL';
                formatter.mbUnit = 'MILLÓN';
                break;
            case 'CL':
                formatter.thousands = '.';
                formatter.decimal = ',';
                formatter.decimalsNum = 0; // 智力不展示小数部分
                formatter.kUnit = 'MIL';
                formatter.mbUnit = 'MILLÓN';
                break;
            case 'PE':
                formatter.kUnit = 'MIL';
                formatter.mbUnit = 'MILLÓN';
                break;
            case 'ID':
                formatter.thousands = '.';
                formatter.decimal = ',';
                formatter.decimalsNum = 0; // 印尼不展示小数部分
                break;
            case 'NG':
                formatter.decimalsNum = 0; // 尼日不展示小数部分
                break;
            case 'PH':
                formatter.decimalsNum = 0;
                break;
            default:
                break;
        }

        let _strNum = String(_num)
        if(Number(_num)>0 && Number(_num)<0.000001){//防止出现类似 1.4e-7 情况
            _strNum = Number(_num).toFixed(8);
        }
        let parts = _strNum.split('.');
        // 添加千位分隔符
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, formatter.thousands);
        return parts.join(formatter.decimal);
    },
    /**根据位数设置小数点长度,例如:
     * maxCnt=7 ,number:
     * 1.123456789              => 1.1234567
     * 10.123456789             => 10.123456
     * 100.123456789            => 100.12345
     * 1234567890123.123456789  => 1234567890123
     */
    setNumberPointByCnt(number,maxCnt,type){
        let cnt10 = Math.max(0,Math.floor(Math.log10(number)));//10 的几次方
        let cnt = Math.max(0,maxCnt-cnt10) //保留小数位数
        if(type=="floor"){
            return Math.floor(number * Math.pow(10, cnt)) / Math.pow(10, cnt)
        }else if(type=="round"){
            return Math.round(number * Math.pow(10, cnt)) / Math.pow(10, cnt)
        }else if(type=="ceil"){
            return Math.ceil(number * Math.pow(10, cnt)) / Math.pow(10, cnt)
        }else{
            console.error('[zutil] setNumberPointByCnt ERROR type:',type)
        }
    },
    /**根据国家获取金额小数点后位数 */
    getDecimalsNum(){
        let decimalsNum = 2;
        let country = getLocalData('country');
        switch (country) {
            case 'MX':
            case 'BR':
            case 'PE':
            case 'AR':
                break;
            case 'CO':// 哥伦比亚不展示小数部分
            case 'CL':// 智力不展示小数部分
            case 'ID':// 印尼不展示小数部分
            case 'NG':// 尼日不展示小数部分
            case 'PH':
                decimalsNum = 0;
                break;
            default:
                break;
        } 
        return decimalsNum;
    },

    /** 根据国家获取小数点后 n 位的最小单位 */
    getMinUnitByCountry() {
        let n = this.getDecimalsNum()
        return this.getMinUnit(n)
    },

    /**获取小数点后 n 位的最小单位
     * @param {number} n - 小数位数
     * @returns {number}
     */
    getMinUnit(n){
        if (n <= 0) return 1
        return 1 / (10 ** n)
    },

    /**获取格式化赚钱收益string (按国家)
    - 当金额大于等于标准货币最小值时，按标准货币显示,例如：
        - 墨西哥：0.01345344，显示为：0.01
        - 哥伦比亚：5,01345344，显示为：5
    - 当金额小于标准货币最小值时，显示小数点后8位,例如：
        - 墨西哥：0.00000344，显示为：0.00000344
        - 哥伦比亚：0,00000344，显示为：0,00000344
     */
    getEarnInterestAmount(_amount){
        let _amountStr = formatPrice(_amount)
        if(_amount>0 && _amount < this.getMinUnitByCountry()){
            _amount = this.setNumberPointByCnt(_amount,8,'round')
            _amountStr = this.numberFormatStr(_amount);
        }
        return _amountStr
    },

    /**获取网络请求错误信息 */
    getErrMsg(err) {
        let errMsg = '[timeout]';
        if (err) {
            if (err.msg) {
                errMsg = err.msg;
            } else if (err.errMsg) {
                errMsg = err.errMsg;
            }
        }
        return errMsg;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // test ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    testNumber:0,
    test(param) {
        window.log("[zutil] test param",param)

        // let page = "/pages/activitys/earnInterest/earnInterest"
        // // let page = "/pages/activitys/testActivity"
        // window.log("gotoPage",page)
        // gotoPage({ page });

        // const store = useCommonStore();
        // store.setIsEarnInterest(!store.isEarnInterest);
        
        // window.log("[zutil] test isEarnInterest",store.isEarnInterest)
        return;
        


        this.setChatUnreadCount(chatUnreadCount.value+1)//客服信息+1

        // let content = "[{\"amount\":80.0,\"gameInfo\":{\"gameId\":3,\"gameImg\":\"https://files.igming.com/statics/2024/03/22/WINGS_OF_RA_300X300_20240222054833A128_20240322012926A002.jpg\",\"gameName\":\"SlotGameWings\",\"gameSupplierCode\":\"TALARA\"},\"loginUserName\":\"zj1\",\"marqueeType\":1,\"platform\":\"MX_1\",\"systemCreate\":0,\"userId\":3554,\"userName\":\"zj1\"},{\"amount\":20.0,\"gameInfo\":{\"gameId\":983,\"gameImg\":\"https://files.001mx.uk/statics/2025/07/15/testPic_20250715012004A002.png\",\"gameName\":\"test\",\"gameSupplierCode\":\"TALARA\"},\"loginUserName\":\"zj1\",\"marqueeType\":1,\"platform\":\"MX_1\",\"systemCreate\":0,\"userId\":3554,\"userName\":\"zj1\"},{\"amount\":15.0,\"gameInfo\":{\"gameId\":3,\"gameImg\":\"https://files.igming.com/statics/2024/03/22/WINGS_OF_RA_300X300_20240222054833A128_20240322012926A002.jpg\",\"gameName\":\"SlotGameWings\",\"gameSupplierCode\":\"TALARA\"},\"loginUserName\":\"zj1\",\"marqueeType\":1,\"platform\":\"MX_1\",\"systemCreate\":0,\"userId\":3554,\"userName\":\"zj1\"},{\"amount\":11.6,\"gameInfo\":{\"gameId\":3,\"gameImg\":\"https://files.igming.com/statics/2024/03/22/WINGS_OF_RA_300X300_20240222054833A128_20240322012926A002.jpg\",\"gameName\":\"SlotGameWings\",\"gameSupplierCode\":\"TALARA\"},\"loginUserName\":\"zj1\",\"marqueeType\":1,\"platform\":\"MX_1\",\"systemCreate\":0,\"userId\":3554,\"userName\":\"zj1\"},{\"amount\":5.0,\"gameInfo\":{\"gameId\":983,\"gameImg\":\"https://files.001mx.uk/statics/2025/07/15/testPic_20250715012004A002.png\",\"gameName\":\"test\",\"gameSupplierCode\":\"TALARA\"},\"loginUserName\":\"zj1\",\"marqueeType\":1,\"platform\":\"MX_1\",\"systemCreate\":0,\"userId\":3554,\"userName\":\"zj1\"},{\"amount\":2.8,\"gameInfo\":{\"gameId\":3,\"gameImg\":\"https://files.igming.com/statics/2024/03/22/WINGS_OF_RA_300X300_20240222054833A128_20240322012926A002.jpg\",\"gameName\":\"SlotGameWings\",\"gameSupplierCode\":\"TALARA\"},\"loginUserName\":\"zj1\",\"marqueeType\":1,\"platform\":\"MX_1\",\"systemCreate\":0,\"userId\":3554,\"userName\":\"zj1\"},{\"amount\":2.5,\"gameInfo\":{\"gameId\":3,\"gameImg\":\"https://files.igming.com/statics/2024/03/22/WINGS_OF_RA_300X300_20240222054833A128_20240322012926A002.jpg\",\"gameName\":\"SlotGameWings\",\"gameSupplierCode\":\"TALARA\"},\"loginUserName\":\"zj1\",\"marqueeType\":1,\"platform\":\"MX_1\",\"systemCreate\":0,\"userId\":3554,\"userName\":\"zj1\"},{\"amount\":2.0,\"gameInfo\":{\"gameId\":3,\"gameImg\":\"https://files.igming.com/statics/2024/03/22/WINGS_OF_RA_300X300_20240222054833A128_20240322012926A002.jpg\",\"gameName\":\"SlotGameWings\",\"gameSupplierCode\":\"TALARA\"},\"loginUserName\":\"zj1\",\"marqueeType\":1,\"platform\":\"MX_1\",\"systemCreate\":0,\"userId\":3554,\"userName\":\"zj1\"}]"
        // let mmsg = JSON.parse(content);
        // window.log("test mmsg",mmsg);
        // const store = useCommonStore();
        // store.setMarqueeList(shuffleArray(mmsg));


        // const store = useCommonStore();
        // let XmasActivityDialo = store.isShowXmasActivityDialog
        // window.log("[zutil] test XmasActivityDialo",XmasActivityDialo);
        // if(!XmasActivityDialo){
        //     let popDate = getLocalData(`${store.baseUserInfo.userName}-XmasRechargePop`);
        //     let today = dateFormat();
        //     if(popDate == today){
        //         window.log("圣诞活动弹窗已经弹出一次")
        //     }else{
        //     }
        //     store.setIsShowXmasActivityDialog(true)
        // }

        // let socketData = {
        //     code: "CHRISTMAS_GIFT_ONLINE_NOTICE",
        //     content: "{\"buyPeoples\":953,\"rewardAmountTotal\":13000.0}",
        //     isStation: false,
        //     platform: "MX_1",
        //     title: "",
        //     type: 1,
        //     userName: "zj2"
        // }

        let showXmas = getLocalData('showXmas')
        window.log("[zutil] test showXmas",showXmas)
        if(showXmas === '1'){
            // let firstBuyPopDataArr = [
            //     null,
            //     {idx:1,rwd:200,day:1,totalRwd:2000},
            //     {idx:2,rwd:300,day:2,totalRwd:3000},
            //     null,
            //     {idx:4,rwd:500,day:7,totalRwd:5000},
            //     null
            // ]
            // let mainPopData ={type:1,sellCnt:5000000,maxRwd:2000000};
    
            // this.setXmasLocalData("firstBuyPopDataArr",firstBuyPopDataArr)
            // this.setXmasLocalData("mainPopData",mainPopData)
            // const store = useCommonStore();
            // store.setIsShowXmasActivityDialog(true)
            // uni.$emit('XmasRechargeActivity', { msg: 'XmasRechargeActivity'})

            // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ 弹窗相关 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
            if(false){
                //活动上线弹窗
                let socketData1 = {
                    code: "CHRISTMAS_GIFT_ONLINE_NOTICE",
                    content: "{\"buyPeoples\":953,\"rewardAmountTotal\":13000.0}",
                    isStation: false,
                    platform: "MX_1",
                    title: "",
                    type: 1,
                    userName: "zj2"
                }
    
                //返现领取提示弹窗 
                let socketData2 = {
                    code: "CHRISTMAS_GIFT_RECEIVE_NOTICE",
                    // content: "[{\"index\":1,\"rewardAmountTotal\":220.0,\"currentDayRewardAmount\":0,\"receiveAmountTotal\":0,\"status\":1},{\"index\":2,\"rewardAmountTotal\":450.0,\"currentDayRewardAmount\":240,\"receiveAmountTotal\":240.0,\"status\":3},{\"index\":3,\"rewardAmountTotal\":1200.0,\"currentDayRewardAmount\":0,\"receiveAmountTotal\":0,\"status\":1},{\"index\":4,\"rewardAmountTotal\":2500.0,\"currentDayRewardAmount\":1200,\"receiveAmountTotal\":1200.0,\"status\":2},{\"index\":5,\"rewardAmountTotal\":5600.0,\"currentDayRewardAmount\":0,\"receiveAmountTotal\":0,\"status\":1},{\"index\":6,\"rewardAmountTotal\":13000.0,\"currentDayRewardAmount\":6000,\"receiveAmountTotal\":6000.0,\"status\":3}]",
                    // content: "[{\"index\":1,\"rewardAmountTotal\":220.0,\"currentDayRewardAmount\":0,\"receiveAmountTotal\":0,\"status\":1},{\"index\":2,\"rewardAmountTotal\":450.0,\"currentDayRewardAmount\":0,\"receiveAmountTotal\":0,\"status\":1},{\"index\":3,\"rewardAmountTotal\":1200.0,\"currentDayRewardAmount\":0,\"receiveAmountTotal\":0,\"status\":1},{\"index\":4,\"rewardAmountTotal\":2500.0,\"currentDayRewardAmount\":0,\"receiveAmountTotal\":1200.0,\"status\":2},{\"index\":5,\"rewardAmountTotal\":5600.0,\"currentDayRewardAmount\":0,\"receiveAmountTotal\":0,\"status\":1},{\"index\":6,\"rewardAmountTotal\":13000.0,\"currentDayRewardAmount\":0,\"receiveAmountTotal\":0,\"status\":1}]",
                    content: "[{\"index\":1,\"rewardAmountTotal\":220.0,\"currentDayRewardAmount\":50,\"receiveAmountTotal\":120.0,\"status\":2},{\"index\":2,\"rewardAmountTotal\":450.0,\"currentDayRewardAmount\":240,\"receiveAmountTotal\":340.0,\"status\":3},{\"index\":3,\"rewardAmountTotal\":1200.0,\"currentDayRewardAmount\":0,\"receiveAmountTotal\":0,\"status\":1},{\"index\":4,\"rewardAmountTotal\":2500.0,\"currentDayRewardAmount\":1200,\"receiveAmountTotal\":1700.0,\"status\":3},{\"index\":5,\"rewardAmountTotal\":5600.0,\"currentDayRewardAmount\":0,\"receiveAmountTotal\":0,\"status\":1},{\"index\":6,\"rewardAmountTotal\":13000.0,\"currentDayRewardAmount\":6000,\"receiveAmountTotal\":6000.0,\"status\":3}]",
                    isStation: false,
                    platform: "MX_1",
                    title: "",
                    type: 1,
                    userName: "zj2",
                }
    
                // 购买,第一天自动领取
                let socketData0 = {
                    code: "CHRISTMAS_GIFT_FIRST_RECEIVE_NOTICE",
                    // content: "{\"index\":2,\"rewardAmountTotal\":450.0,\"currentDayRewardAmount\":240,\"receiveAmountTotal\":240,\"status\":3}",
                    content: "{\"index\":2,\"rewardAmountTotal\":450.0,\"currentDayRewardAmount\":240,\"receiveAmountTotal\":240,\"status\":3}",
                    isStation: false,
                    platform: "MX_1",
                    title: "",
                    type: 1,
                    userName: "zj3"
                }
    
                // const rand = Math.floor(Math.random() * 3);
                // window.log("[zutil] test rand",rand)
                this.testNumber++;
                if(this.testNumber>=3){
                    this.testNumber = 0;
                }
                window.log("[zutil] test this.testNumber",this.testNumber)
                if(this.testNumber == 0){
                    this.onSocketData(socketData0);
                }else if(this.testNumber == 1){
                    this.onSocketData(socketData1);
                }else if(this.testNumber == 2){
                    this.onSocketData(socketData2);
                }
                // this.onSocketData(socketData0);
    
                // //注册送转盘弹窗
                // let socketData = {
                //     code: "NEWBIE_GIFT_JOIN_NOTICE",
                //     content: "{\"registerTime\":1764900819505,\"expiredTime\":\""+ (Date.now()+10000) +"\",\"max\":450.0,\"min\":350.0,\"show\":\"500\"}",
                //     isStation: false,
                //     platform: "MX_test",
                //     title: "",
                //     type: 1,
                //     userName: "MX326957",
                // }
                // this.onSocketData(socketData);
    
                // //注册后用户名密码显示弹窗
                // const store = useCommonStore();
                // store.switchIsShowRegisterUserInfoDialog(true);
                // //每日签到弹窗
                // // const store = useCommonStore();
                // setLocalData(`${store.baseUserInfo.userName}-signin`, '');

                // //圣诞树弹窗
                // let socketData = {
                //     code: "CHRISTMAS_TREE_NOTICE",
                //     content: "{\"day\":10,\"amount\":200.0}",
                //     isStation: false,
                //     platform: "MX_test",
                //     title: "",
                //     type: 1,
                //     userName: "zj4",
                // }
                // this.onSocketData(socketData);
            }

            // this.setXmasLocalData("onlinePop",'');
            // this.setXmasLocalData("receivePop",'');
        }

    }
}